<template>
  <!-- VER PDF -->
  <v-dialog v-model="dialogAsignarAlumno.estatus" max-width="400px" persistent>
    <v-card>
      <v-card-title></v-card-title>
        <v-card-text class="black--text text-center" >
          Selecciona una vendedora para asignar el alumno
          <br/>
          <br/>
          <br/>

          <v-autocomplete
            filled
            dense
            clearable
            v-model="alumnoSeleccionado"
            :items="filterAlumnos"
            label="Selecciona un alumnos"
            hide-details
            item-text="alumno_completo_asignado"
            return-object
            item-value="id_alumno"
          >
          </v-autocomplete>
            </v-card-text>
            <v-card-actions>
              <v-btn 	
                color="grey" 
                icon 
                dark 
                small 
                @click="dialogAsignarAlumno.estatus = false"
                absolute
                top
                right
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green" block large class="text-capitalize" dark  @click="iniciarReasignacion( )">Sí, seguro</v-btn>
          </v-card-actions>
        </v-card>
      <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
  </v-dialog>
</template>

<script>
  import axios from 'axios';

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'


  export default {

    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

    props:[
      'dialogAsignarAlumno',
      'alumno',
      'wha',
      'chat',
      'alumnos',
      'chats'
    ],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      alumnoSeleccionado: null,

    }),

    computed:{

      filterAlumnos() {
        const chats = Array.isArray(this.chats) ? this.chats : []
        const alumnos = Array.isArray(this.alumnos) ? this.alumnos : []

        return alumnos.map((alumno) => {
          const nombre = alumno.alumno_completo
            || [alumno.alumno, alumno.matricula].filter(Boolean).join(' ')
            || alumno.alumno
            || 'Sin nombre'
          const existeUsuario = chats.find((el) => el.id_alumno == alumno.id_alumno)
          const alumno_completo_asignado = existeUsuario
            ? `${nombre} (${existeUsuario.usuario})`
            : nombre

          return { ...alumno, alumno_completo_asignado }
        })
      }

    },


    methods: {
      iniciarReasignacion(){

        // Mandamos los datos completos
        const payload = {
          idalumno        : this.alumnoSeleccionado.id_alumno,
          twilio_asignado : this.chat.usuario
        }

        
        return this.$http.post('asignacion.alumno.whatsapp', payload ).then(response=>{

          this.chat['alumno']    = this.alumnoSeleccionado.alumno
          this.chat['id_alumno'] = this.alumnoSeleccionado.id_alumno


          this.dialogAsignarAlumno.estatus = false
          this.prospectosAReasignar = null
          this.vendedoraUnica       = null

          this.validarSuccess('Datos reasignados correctamente')
          this.dialogAlerta = false
          this.cargar       = false
          // Agregarmos primero los datos
              
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      }
    },
  }
</script>
<style  scoped>


</style>

